import { Injectable, signal } from '@angular/core'
import { ConsentService } from './consent.service'

// eslint-disable-next-line
declare const Cookiebot: any

@Injectable({ providedIn: 'root' })
export class WebConsentService extends ConsentService {
	async ask(): Promise<void> {
		Cookiebot.renew()
	}

	canShowForm = signal(true)
}
